import { render, staticRenderFns } from "./LiveFeedEntry.vue?vue&type=template&id=1b8744d1&scoped=true&"
import script from "./LiveFeedEntry.vue?vue&type=script&lang=ts&"
export * from "./LiveFeedEntry.vue?vue&type=script&lang=ts&"
import style0 from "./LiveFeedEntry.vue?vue&type=style&index=0&id=1b8744d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8744d1",
  null
  
)

export default component.exports